import { baseUrl } from './constants';
import { toast } from 'react-toastify';
import axios from 'axios'

const PutObject = async (type, obj) => {
  const authTokens = JSON.parse(localStorage.getItem('tokens'));
  const headers = { Authorization: `${authTokens.token}`, 'Content-Type': 'application/json' };
  const { _id, ...data } = obj

  try {
    const response = await axios({
      url: (_id) ? `${baseUrl}/${type}/${_id}` : `${baseUrl}/${type}`,
      method: 'put',
      data,
      headers
    });

    if (response.status === 201 || response.status === 200 || response?.data?.data?.status === 200) {
      toast.success(response.data.message);
      return response.data;
    }

    throw new Error('Invalid response status');

  } catch (error) {
    console.error(error);
    toast.error(error?.response?.data?.message || error.message);
    throw error;
  }
}

export default PutObject;
